/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classnames from 'classnames';
import * as React from 'react';

import { orderTemplateListStatus } from '../order-template-list';

export interface IOrderTemplateListStatusMessageProps {
    className?: string;
    errorType: orderTemplateListStatus;
    text?: string;
}

export const OrderTemplateListStatusMessage: React.FC<IOrderTemplateListStatusMessageProps> = ({ className, errorType, text }) => {
    switch (errorType) {
        case 'EMPTY':
            return <p className={classnames('ms-orderTemplateList__message-empty', className)}>{text}</p>;
        case 'FAILED':
            return <p className={classnames('ms-orderTemplateList__message-failed', className)}>{text}</p>;
        case 'LOADING':
        default:
            return <p className='ms-orderTemplateList__message-waiting'>{text}</p>;
    }
};
